<template>
    <div class="row controls">
        <div class="seriesBox">
            <base-button-1 v-for="serie in eventTimes" :key="serie.number"
                :disabled="!serie.series_start || !serie.series_end" class="seriesBox__button"
                :class="{ 'seriesBox__button--active': (serie.number === selectedSerieNumber) }"
                @click="setSerie(serie)">
                <i class="fas fa-camera"></i>
                Seria #{{ serie.number }}
            </base-button-1>
        </div>
        <div class="controls__box">
            <div class="controls__box-buttons">
                <!-- 
                <img v-if="!isPlay" class="pointer" @click="start()" src="../assets/images/play.svg" alt />
                -->
                <div v-if="!isPlay" class="pointer">
                    <i class="fas fa-play w24" @click="start()"></i>
                </div>
                <div v-else class="pointer">
                    <i class="fas fa-pause w24" @click="stop()"></i>
                </div>
            </div>
            <div class="relative">
                <h5 class="controls__box-speed" @click="showSpeed = !showSpeed">
                    {{ value * 100 }}x
                </h5>
                <div class="controls__box-values" v-if="showSpeed">
                    <div class="mat12" v-for="val in values" :key="val" @click="changeSpeedValue(val)">
                        {{ val * 100 }}x
                    </div>
                </div>
            </div>
            <div class="mar24">{{ durationTime }}</div>
            <input type="range" @input="changeSlider" :min="startTime" :max="finishTime" :value="currentPlaybackTime"
                :step="100" class="controls__bar" name="time" />
        </div>
    </div>
</template>

<script>
import moment from 'moment'
import { mapGetters, mapMutations } from 'vuex'
import _ from 'lodash'
import {
    isAwardedMarker,
    isLocatedInTrackBoundsZone,
    hideMarker,
    showMarker,
    hasSelectedClassification,
    isSpecial,
    setHighlightMarker,
    setNormalMarker,
    setDisabledMarker,
} from '@/service/playback'
import { SET_FOCUS_DEVICE_ID, SET_SELECTED_SERIE_NUMBER } from '@/store/mutations.type'
import BaseButton1 from './BaseButton1.vue'
export default {
    components: {
        BaseButton1
    },
    props: {
        playback: {
            type: Object,
            required: true,
        },
    },
    data() {
        return {
            value: 0.1,
            showSpeed: false,
            values: [0.1, 0.2, 0.5, 0.8, 1],
            isPlay: false,
            currentPlaybackTime: 0,
            startTime: 0,
            finishTime: 10,
        }
    },
    created() {
        this.setCurrentPlaybackTime()
        window.playbackTimeInterval = setInterval(
            this.setCurrentPlaybackTime,
            100
        )
        this.startTime = this.playback.getStartTime()
        this.finishTime = this.playback.getEndTime()
    },
    beforeDestroy() {
        clearInterval(window.playbackTimeInterval)
        this.SET_SELECTED_SERIE_NUMBER(null)
    },
    computed: {
        ...mapGetters([
            'awardedDeviceIds',
            'playbackMarkers',
            'isHighlightedDevicesView',
            'tracksBounds',
            'selectedClassificationId',
            'selectedSerieNumber',
            'eventTimesData',
            'devices',
            'players',
            'focusDeviceId',
            'serieTimesInMs'
        ]),
        eventTimes() {
            const clx = this.eventTimesData?.classifications?.find(c => c.external_id === this.selectedClassificationId);
            return clx?.series || [];
        },
        durationTime() {
            let diff, currentTime, duration, startTime, durationTime
            currentTime = moment(this.currentPlaybackTime * 1000)
            startTime = moment(this.playback.getStartTime() * 1000)
            if (currentTime < startTime) {
                currentTime = startTime
            }
            diff = currentTime.diff(startTime)
            duration = moment.duration(diff)
            let days = duration.get('d')
            durationTime = moment
                .utc(duration.asMilliseconds())
                .format('HH:mm:ss')
            if (days > 0) {
                // [hh, mm, ss]
                let timeElements = durationTime.split(':')
                let dayHours = Number.parseInt(days) * 24
                timeElements[0] = Number.parseInt(timeElements[0]) + dayHours
                return timeElements.join(':')
            }
            return durationTime
        },
    },

    methods: {
        ...mapMutations([SET_FOCUS_DEVICE_ID, SET_SELECTED_SERIE_NUMBER]),
        setCurrentPlaybackTime() {
            this.currentPlaybackTime = this.playback.getTime()
        },
        changeSpeedValue(speed) {
            this.playback.setSpeed(speed)
            this.value = speed
            this.showSpeed = false
        },
        start() {
            if (this.selectedSerieNumber && this.currentPlaybackTime > this.finishTime) {
                return
            } else {
                this.playback.start()
                this.isPlay = !this.isPlay
            }
        },
        stop() {
            this.playback.stop()
            this.isPlay = !this.isPlay
        },
        changeSlider(val) {
            this.playback.setCursor(Number.parseFloat(val.target.value))
            this.currentPlaybackTime = this.playback.getTime()
        },
        setSerie(serie) {
            this.SET_SELECTED_SERIE_NUMBER(serie.number)
            this.startTime = this.serieTimesInMs.serieStartTime / 1000
            this.finishTime = this.serieTimesInMs.serieEndTime / 1000
            this.playback.setCursor(this.serieTimesInMs.serieStartTime / 1000)
            this.currentPlaybackTime = this.playback.getTime()
        },
        // Manager for playback markers.
        setPlaybackMarkers() {
            for (let id of Object.keys(this.playbackMarkers)) {
                let player = _.find(this.players, (player) => {
                    return player.deviceId == id
                })

                if (this.isHighlightedDevicesView) {
                    // Awarded view.

                    if (!isAwardedMarker(this.playbackMarkers[id])) {
                        // If not awarded - hide marker.
                        hideMarker(this.playbackMarkers[id])
                    } else if (
                        isAwardedMarker(this.playbackMarkers[id]) &&
                        hasSelectedClassification(player) &&
                        isLocatedInTrackBoundsZone(this.playbackMarkers[id])
                    ) {
                        // If awarded and located in trackbounds - set red marker and show.
                        setHighlightMarker(this.playbackMarkers[id], player)
                        showMarker(this.playbackMarkers[id])
                    } else if (
                        isAwardedMarker(this.playbackMarkers[id]) &&
                        !hasSelectedClassification(player) &&
                        isLocatedInTrackBoundsZone(this.playbackMarkers[id])
                    ) {
                        setDisabledMarker(this.playbackMarkers[id], player)
                    }
                } else {
                    // 'All' view

                    if (
                        (hasSelectedClassification(player) ||
                            isSpecial(player)) &&
                        isLocatedInTrackBoundsZone(this.playbackMarkers[id]) &&
                        !isAwardedMarker(this.playbackMarkers[id])
                    ) {
                        // has classification as currently selected classification
                        // or marker is special and located in trackbounds zone
                        // - set default marker and show .
                        setNormalMarker(this.playbackMarkers[id], player)
                        showMarker(this.playbackMarkers[id])
                    } else if (
                        isAwardedMarker(this.playbackMarkers[id]) &&
                        (hasSelectedClassification(player) ||
                            isSpecial(player)) &&
                        isLocatedInTrackBoundsZone(this.playbackMarkers[id])
                    ) {
                        // awarded marker and same classification as currently selected
                        // and located in trackbounds zone - set red marker.
                        setHighlightMarker(this.playbackMarkers[id], player)
                    } else {
                        // other ways should always hide marker.
                        hideMarker(this.playbackMarkers[id])
                    }
                }
            }
        },
    },
    watch: {
        durationTime() {
            if (this.currentPlaybackTime >= this.finishTime) {
                this.stop()
            }
        },
        selectedClassificationId() {
            if (this.focusDeviceId) {
                this.SET_FOCUS_DEVICE_ID(null)
            }
            this.setPlaybackMarkers()
        },
        isHighlightedDevicesView() {
            this.setPlaybackMarkers()
        },
        awardedDeviceIds: {
            deep: true,
            immediate: true,
            handler() {
                this.setPlaybackMarkers()
            },
        },
    },
}
</script>

<style lang="scss" scoped>
.seriesBox {
    display: flex;
    justify-content: flex-start;
    flex-wrap: wrap;
    gap: 8px;
    padding-bottom: 8px;

    &__button {
        padding: 4px 2px;
        color: #fff;
        background-color: $slate-two;
        gap: 4px;
        width: fit-content;
        padding: 4px 8px;
        height: unset;

        &:hover {
            background-color: darken($slate-two, 8%);
        }

        &--active {
            background-color: orange;

            &:hover {
                background-color: darken(orange, 8%);
            }
        }
    }
}

.controls {
    width: 100%;
    display: flex;
    flex-direction: column;
    padding: 16px 16px 24px 16px;

    // background-color: $white;
    &__bar {
        appearance: none;
        -webkit-appearance: none;
        width: 100%;
        margin-top: 20px;

        @mixin thumb {
            appearance: none;
            height: 16px;
            width: 16px;
            border-radius: 50%;
            background: #ff3d00;
            border: 2px solid #78989c;
            cursor: pointer;
            margin-top: -7px;

        }

        &::-webkit-slider-thumb {
            @include thumb;
        }

        &::-moz-range-thumb {
            @include thumb;
        }

        &::-webkit-slider-runnable-track {
            width: 100%;
            height: 2px;
            cursor: pointer;
            background: #78909c;
            border-radius: 6px;
            box-shadow: inset 0 1px 3px rgba(0, 0, 0, .9);
        }

        &::-moz-range-track {
            width: 100%;
            height: 2px;
            cursor: pointer;
            background: #78909c;
            border-radius: 6px;
            box-shadow: inset 0 1px 3px rgba(0, 0, 0, .9);
        }
    }

    &__box {
        display: flex;
        align-items: center;
        justify-content: flex-start;
        flex-wrap: wrap;

        &-buttons {
            margin-right: 24px;
            display: flex;
        }

        &-speed {
            margin-right: 32px;
            cursor: pointer;
            user-select: none;
        }

        &-values {
            position: absolute;
            bottom: 40px;
            right: 10%;
            z-index: 9999;
            background-color: $white;
            border-radius: 4px;
            box-shadow: 0 8px 12px 0 rgba(0, 0, 0, 0.1),
                0 0 2px 0 rgba(55, 71, 79, 0.2);
            font-size: 16px;
            font-weight: bold;

            & div {
                padding: 6px 16px;
                margin: 8px 2px;
                border-radius: 4px;
                cursor: pointer;

                &:hover {
                    background-color: $slate-two;
                    color: $white;
                }
            }
        }
    }

    // .controls
    @media (min-width: 768px) {
        &__box {
            flex-wrap: nowrap;
        }

        &__bar {
            margin-top: 0;
        }

        padding-bottom: 0;
    }
}

.w24 {
    width: 24px;
}
</style>
